function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styled from 'styled-components';
var svgSize = '2.75rem'; // 44px

var MenuIcon = /*#__PURE__*/styled.svg.withConfig({
  displayName: "MenuIcon",
  componentId: "sc-1nq0eki-0"
})(["color:#fff;fill:currentColor;"]);
var defaultAttrs = {
  focusable: 'false',
  width: svgSize,
  height: svgSize,
  viewBox: '0 0 44 44'
};
var navigationIcons = {
  hamburger: /*#__PURE__*/React.createElement(MenuIcon, _extends({}, defaultAttrs, {
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 29h21v-2.333H12V29zm0-5.833h21v-2.334H12v2.334zM12 15v2.333h21V15H12z"
  })),
  cross: /*#__PURE__*/React.createElement(MenuIcon, _extends({}, defaultAttrs, {
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.741 15L21.6 20.142 16.458 15 15 16.458l5.142 5.142L15 26.742l1.458 1.458 5.142-5.141 5.141 5.141 1.459-1.458-5.142-5.142 5.142-5.142z",
    fillRule: "evenodd"
  }))
};
export default navigationIcons;